import React, { CSSProperties } from 'react';
import { makeStyles, Theme, useTheme } from '@material-ui/core';

type BlockProps = {
    children: React.ReactNode,
    /**
     * margin
     */
    m?: number,
    /**
     * padding
     */
    p?: number,
    row?: boolean,
    justifyContent?: CSSProperties['justifyContent'],
    alignItems?: CSSProperties['alignItems'],
    flex?: CSSProperties['flex'],
    style?: React.CSSProperties,
};

Block.defaultProps = {
    m: 0,
    p: 0,
    row: false,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flex: 'none',
    style: {},
};

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
}));

function Block(props: BlockProps): React.ReactElement {
    const {
        children,
        m = Block.defaultProps.m,
        p = Block.defaultProps.p,
        row = Block.defaultProps.row,
        justifyContent = Block.defaultProps.justifyContent,
        alignItems = Block.defaultProps.alignItems,
        flex = Block.defaultProps.flex,
        style = Block.defaultProps.style,
    } = props;
    const classes = useStyles();
    const theme = useTheme();

    return (
        <div
            className={classes.container}
            style={{
                margin: theme.spacing(m),
                padding: theme.spacing(p),
                flexDirection: row ? 'row' : 'column',
                justifyContent,
                alignItems,
                flex,
                ...style,
            }}
        >
            {children}
        </div>
    );
}

export { Block };
